import { createTheme } from "@mui/material";
import colors from '../css/colors'

const theme = createTheme({
    palette: {
        primary: {
            main: colors.palette.primary
        },
        secondary: {
            main: colors.palette.secondary
        },
        info: {
            main: colors.palette.info
        },
        warning: {
            main: colors.palette.warning
        },
        success: {
            main: colors.palette.confirm
        },
        error: {
            main: colors.palette.error
        },
        cardsText: {
            main: colors.palette.cardsText
        }
    },
    typography: {
        h1: {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 'calc(.95rem * 2.5)',
            lineHeight: "32px",
            color: colors.grayScale[1]
        },
        h2: {
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "calc(.95rem * 2)",
            lineHeight: "48px",
            color: colors.grayScale[1]
        },
        h3: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "calc(.95rem * 1.75)",
            lineHeight: "24px",
            color: colors.grayScale[1]
        },
        h4: {
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "calc(.95rem * 1.5)",
            lineHeight: "24px",
            color: colors.grayScale[4]
        },
        h5: {
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "calc(.95rem * 1.25)",
            lineHeight: "16px"
        },
        body1: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "calc(.95rem * 1)",
            lineHeight: "24px",
            color: colors.grayScale[4]
        },
        body2: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "calc(.95rem * 0.95)",
            lineHeight: "24px",
            color: colors.grayScale[4]
        },
		caption: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "normal",
			lineHeight: "16px",
			color: colors.grayScale[3]
		},
    }
});

export default theme;